import React from 'react';
import { StarField } from './components/StarField';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { TeamSection } from './components/TeamSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative min-h-screen bg-[#0a0e27] text-slate-200 selection:bg-cyan-500/30 selection:text-cyan-200" data-id="element-0">
      <StarField data-id="element-1" />

      <div className="relative z-10 flex flex-col" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <HeroSection data-id="element-5" />
          <ProblemsSection data-id="element-6" />
          <FeaturesSection data-id="element-7" />
          <PricingSection data-id="element-8" />
          <TeamSection data-id="element-9" />
        </main>
        <Footer data-id="element-10" />
      </div>
    </div>;
}